import type { LearnosityData } from 'type-props/learnosity-types';

import { createActionWithPayload, createAction } from 'actions/utils';

export const ACTIONS = {
  SET_LEAROSITY_OBJECT: 'SET_LEAROSITY_OBJECT',
  SET_RESPONSE_ID_REFERENCE_MAP: 'SET_RESPONSE_ID_REFERENCE_MAP',
  CLEAR_LEARNOSITY_CONFIG: 'CLEAR_LEARNOSITY_CONFIG',
} as const;

export const setLeanosityObject = createActionWithPayload<
  typeof ACTIONS.SET_LEAROSITY_OBJECT,
  { learnosityObject: LearnosityData }
>(ACTIONS.SET_LEAROSITY_OBJECT);

export const setResponseTOReferenceMap = createActionWithPayload<
  typeof ACTIONS.SET_RESPONSE_ID_REFERENCE_MAP,
  { responseIdReferenceMap: Record<string, string> }
>(ACTIONS.SET_RESPONSE_ID_REFERENCE_MAP);

export const clearLearnosityConfig = createAction<typeof ACTIONS.CLEAR_LEARNOSITY_CONFIG>(
  ACTIONS.CLEAR_LEARNOSITY_CONFIG,
);
